// src/components/NotificationCenter.tsx
import React from 'react';
import { useAppContext } from '../hooks/useAppContext';
import ProgressTracker from './ProgressTracker';
import ToastContainer from './ToastContainer';
import './NotificationCenter.css';

const NotificationCenter: React.FC = () => {
  const { state } = useAppContext();
  const { activeJobs, toasts } = state;

  const hasNotifications = activeJobs.length > 0 || toasts.length > 0;

  if (!hasNotifications) {
    return null;
  }

  return (
    <div className="notification-center">
      <ToastContainer />
      <ProgressTracker />
    </div>
  );
};

export default NotificationCenter;